import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { CancelButton, CreateButton } from "../pages/css components/Button";

export default function EditButtons({ ID, editState, setEditState }) {
  const navigate = useNavigate();

  function handleCancel() {
    if (ID && editState) {
      setEditState(!editState);
    } else {
      navigate(-1);
    }
  }

  return (
    <Fragment>
      {!editState && (
        <CreateButton
          size="large"
          variant="contained"
          onClick={() => setEditState(!editState)}
        >
          Edit
        </CreateButton>
      )}

      <CancelButton
        style={{ marginLeft: "8px" }}
        variant="outlined"
        onClick={handleCancel}
      >
        Back
      </CancelButton>
    </Fragment>
  );
}
